import './fonts.css';
const root = document.getElementById('root');
root.innerHTML = '<p style="padding:40px;font-family:sans-serif" role="status">Загружаем ТАТМЯСО…</p>';
async function start() {
  try {
    const response = await fetch('/api/content', { cache: 'no-store', signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error('content');
    window.__TATMYASO_CONTENT__ = (await response.json()).content;
    if (location.pathname.replace(/\/$/, '') === '/staff') await import('./staff-entry.jsx');
    else if (location.pathname.replace(/\/$/, '') === '/admin') await import('./admin-entry.jsx');
    else await import('./main.jsx');
  } catch {
    if (import.meta.env.DEV) { await import(location.pathname === '/staff' ? './staff-entry.jsx' : location.pathname === '/admin' ? './admin-entry.jsx' : './main.jsx'); return; }
    root.innerHTML = '<div style="padding:40px;font-family:sans-serif"><h1>Не удалось загрузить сайт</h1><p>Проверьте соединение и обновите страницу.</p><button onclick="location.reload()">Повторить</button></div>';
  }
}
start();
